import { render, staticRenderFns } from "./UpdateAd.vue?vue&type=template&id=563b8854&scoped=true&"
import script from "./UpdateAd.vue?vue&type=script&lang=js&"
export * from "./UpdateAd.vue?vue&type=script&lang=js&"
import style0 from "./UpdateAd.vue?vue&type=style&index=0&id=563b8854&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "563b8854",
  null
  
)

export default component.exports